// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3t8Li","left":"InfoRow_left__3WcMV"};